import { MenuItemProps, useTranslations } from "@bsm/component";

export const useLineMenu = (): MenuItemProps[] => {
    const [
        EDIT,
        DELETE,
    ] = useTranslations(i18n)

    return [
        {
            ke: "edit",
            label: EDIT,
            startIcon: 'fa-solid fa-pencil',
        },
        {
            ke: "delete",
            label: DELETE,
            startIcon: 'fa-solid fa-trash',

        },
       ];
}

const i18n = [
   "std_edit",
   "std_delete",
]


